<template>
<div class="chapter">
<div class="inner_page">
<div id="toc" style="font-weight:bold;"><h1 id="toc-title">Time – Space – Taste</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#introduction">Introduction</a></li>
<li id="toc-li-5"><a href="#/text/ch005#list-of-illustrations">List of Illustrations</a></li>
<li id="toc-li-7"><a href="#/text/ch006#chapter-1-a-beginning">Chapter 1: A Beginning</a></li>
<li id="toc-li-9"><span href="#/text/ch007#chapter-2-time-passing" title="Link target outside of Sample">Chapter 2: Time Passing</span></li>
<li id="toc-li-11"><span href="#/text/ch008#chapter-3-time-past" title="Link target outside of Sample">Chapter 3: Time Past</span></li>
<li id="toc-li-13"><span href="#/text/ch009#chapter-4-time-gentlemen-please" title="Link target outside of Sample">Chapter 4: Time, Gentlemen, Please</span></li>
<li id="toc-li-15"><span href="#/text/ch010#chapter-5-time-space-mysteries" title="Link target outside of Sample">Chapter 5: Time &amp; Space Mysteries</span></li>
<li id="toc-li-18"><span href="#/text/ch011#chapter-6-time-summary-reading-list" title="Link target outside of Sample">Chapter 6: Time Summary &amp; Reading List</span></li>
<li id="toc-li-19"><span href="#/text/ch012#reading-list-and-acknowledgements" title="Link target outside of Sample">Reading List and Acknowledgements</span></li>
<li id="toc-li-21"><span href="#/text/ch013#appendix-time-and-times-compendium" title="Link target outside of Sample">Appendix Time and Times Compendium</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?64247e92